import React from "react";
import {
  ProjectCardExpanded,
  ProjectExpandedImage,
  ProejctExpandedData,
  ProjectTechContainer,
  ProjectLink,
} from "./projectOverview.styles";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Icon } from "@iconify/react";
import skills from "../../utils/skills.data";

import Slider from "react-slick";

const ProjectExpandedCard = ({ project, closeCard }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  return (
    <ProjectCardExpanded layoutId={`${project.name}`}>
      <Icon
        icon="eva:close-circle-fill"
        color="#000"
        fontSize="1.5em"
        className="close-icon"
        onClick={closeCard}
      />
      <Slider {...settings}>
        {project?.images.map((img) => (
          <ProjectExpandedImage url={img} />
        ))}
      </Slider>
      <ProejctExpandedData>
        <h1 className="project-name">{project.name}</h1>
        <p>{project.description}</p>
        <div className="project-tech">
          {project?.tech.map((i) => (
            <ProjectTechContainer>{skills[i].name}</ProjectTechContainer>
          ))}
        </div>

        <div className="project-links">
          <ProjectLink
            href={project.github}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon icon="codicon:github" color="#000" fontSize="1.2em" /> GITHUB
          </ProjectLink>
          <ProjectLink
            href={project.website}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon icon="mdi:web" color="#000" fontSize="1.2em" /> WEBSITE
          </ProjectLink>
        </div>
      </ProejctExpandedData>
    </ProjectCardExpanded>
  );
};

export default ProjectExpandedCard;

{
  /* <ProjectCardExpanded layoutId={`${project.name}`}>

</ProjectCardExpanded> */
}
